import React from 'react';
import { Chip, ChipProps } from '@mui/material';

export interface ReportingBadgeProps {
  label: string;
  variant: 'success' | 'warning' | 'danger' | 'info' | 'neutral';
}

const VARIANT_COLOR_MAP: Record<ReportingBadgeProps['variant'], ChipProps['color']> = {
  success: 'success',
  warning: 'warning',
  danger: 'error',
  info: 'info',
  neutral: 'default',
};

export const ReportingBadge: React.FC<ReportingBadgeProps> = ({ label, variant }) => (
  <Chip
    label={label}
    size="small"
    color={VARIANT_COLOR_MAP[variant] || 'default'}
    sx={{ fontWeight: 600, fontSize: '0.72rem', height: 22 }}
  />
);
